(function() {
	'use strict';

	angular.module('quantixApp').factory('RatingListService',
			RatingListService);

	RatingListService.$inject = [ '$resource', '$q', '$http' ];

	function RatingListService($resource, $q, $http) {
		
		//added for getting CrisilSMERatingsList data
		var _getCrisilSMERatingsList = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/ratingList/getCrisilSMEOrNSICRatingsList';

			$http.post(url, searchText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		//added for getting CrisilNSICRatingsList data
		var _getCrisilNSICRatingsList = function(nsicInput) {
			var deferred = $q.defer();
			var url = 'api/ratingList/getCrisilSMEOrNSICRatingsList';

			$http.post(url, nsicInput).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		//added for getting CrisilSFRatingsList data
		var _getCrisilSFRatingsList = function(sfdata) {
			var deferred = $q.defer();
			var url = 'api/ratingList/getCrisilSFRatingsList';

			$http.post(url,sfdata).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		//added for getting CreditRatingsList data
		var _getCrisilCreditRatingsList = function(inputData) {
			var deferred = $q.defer();
			var url = 'api/ratingList/getCreditRatingsList';

			$http.post(url,inputData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		//added for getting ConsolidatedRatingsList data
		var _getConsolidatedRatingsList = function() {
			var deferred = $q.defer();
			var url = 'api/ratingList/getConsolidatedRatingsList';

			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getConsolidatedFile = function() {
			var deferred = $q.defer();
			var url = 'api/ratingList/getConsolidatedFile';

			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		//added for getting SF InstrumentList data
		var _getInstrumentList = function() {
			var deferred = $q.defer();
			var url = 'api/ratingList/getInstrumentDetails';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		//added for getting SF RatingTypeList data
		var _getSfRatingType = function() {
			var deferred = $q.defer();
			var url = 'api/ratingList/getSFRatingType';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		//added for getting SF RatingTypeList data
		var _getConstitutionData = function() {
			var deferred = $q.defer();
			var url = 'api/ratingList/getConstitutionDatails';
			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getOthersRatingsList = function(searchRating){
			var deferred = $q.defer();
			var url = 'api/ratingList/getOtherRatingsList';
			$http.post(url , searchRating).then(function(response){
				deferred.resolve(response.data);
			},function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _addAllToPortfolio = function(input){
			var deferred = $q.defer();
			var url = 'api/portfolioresource/addAllToPortfolio';
			$http.post(url,input).then(function(response){
				deferred.resolve(response.data);
			}, function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getRatingAgencyMasterList = function(){
			var deferred = $q.defer();
			var url = 'api/ratingList/getRatingAgencyMasterList';
			$http.post(url).then(function(response){
				deferred.resolve(response.data);
			}, function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getInstrumentsISIN = function(data){
			
			var deferred = $q.defer();
			var url = 'api/ratingList/getInstrumentsISINData';
			$http.post(url,data).then(function(response){
				deferred.resolve(response.data);
			}, function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		
		var _getUnacceptedRating = function(data){
			
			var deferred = $q.defer();
			var url = 'api/ratingList/getUnacceptedRatingData';
			$http.post(url,data).then(function(response){
				deferred.resolve(response.data);
			}, function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getOtherRatingsType = function(){
			
			var deferred = $q.defer();
			var url = 'api/ratingList/getOtherRatingsType';
			$http.post(url).then(function(response){
				deferred.resolve(response.data);
			}, function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		
		return {
			getCrisilNSICRatingsList   : _getCrisilNSICRatingsList,
			getCrisilSMERatingsList    : _getCrisilSMERatingsList,
			getCrisilSFRatingsList     : _getCrisilSFRatingsList, 
			getConsolidatedRatingsList : _getConsolidatedRatingsList,
			getCrisilCreditRatingsList : _getCrisilCreditRatingsList,
			getInstrumentList          : _getInstrumentList,
			getSfRatingType            : _getSfRatingType,
			getConstitutionData       : _getConstitutionData,
			getOthersRatingsList     : _getOthersRatingsList ,
			addAllToPortfolio  : _addAllToPortfolio,
			getRatingAgencyMasterList : _getRatingAgencyMasterList,
			getConsolidatedFile : _getConsolidatedFile,
			getInstrumentsISIN : _getInstrumentsISIN,
			getOtherRatingsType : _getOtherRatingsType,
			getUnacceptedRating : _getUnacceptedRating
		};

	}
})();